import React from "react";
import i18n from '../../../i18n';

export default function MainFooter({mod}) {
  return <footer className={`footer ${mod? 'footer--dark' : ''}`}>
    <div className="container">
      <div className="footer__inner">
        <div className="footer__col">
          <div className="footer__title display5">
            {i18n.t(`main.footer.documents.title`)}
          </div>
          <div className="footer__links">
          
            <a href="/privacy-page?tab=agreement" target="_blank" className="footer__link">{i18n.t(`main.footer.documents.list.doc3`)}</a>
            <a href="/privacy-page?tab=terms" target="_blank" className="footer__link">{i18n.t(`main.footer.documents.list.doc4`)}</a>
            <a href="/privacy-page?tab=offer" target="_blank" className="footer__link">{i18n.t(`main.footer.documents.list.doc5`)}</a>
          </div>
        </div>
        <div className="footer__apps">
          <a href="https://play.google.com/store/apps/details?id=com.uvezem&hl=ru&gl=US" target="_blank">
            <div className="footer__app">
              <div className="footer__app-info">
                <img src="/img/app.svg" alt="" className="footer__app-img"/>
                <div className="footer__app-title text14 gray-text">
                  {i18n.t(`main.footer.app`)}
                </div>
              </div>
              <div className="footer__app-qr">
                <img src="/img/qr.webp" alt=""/>
              </div>
            </div>
          </a>
          <a href="https://max.ru/id2462225394_bot" target="_blank">
            <div className="footer__app">
              <div className="footer__app-info">
                <img src="/img/max.png" alt="" className="footer__app-img"/>
                <div className="footer__app-title text14 gray-text">
                  {i18n.t(`main.footer.bot`)}
                </div>
              </div>
              <div className="footer__app-qr">
                <img src="/img/maxQr.webp" alt=""/>
              </div>
            </div>
          </a>
          <div className="footer__app">
            <div className="footer__app-info">
              <img src="/img/app2.svg" alt="" className="footer__app-img"/>
              <div className="footer__app-title text14 gray-text">
                {i18n.t(`main.footer.botTg`)}
              </div>
            </div>
            <div className="footer__app-qr">
              <img src="/img/tgQr.png" alt=""/>
            </div>
          </div>
        </div>
        <div className="footer__col">
          <div className="footer__title display5">
            {i18n.t(`main.footer.contacts.title`)}
          </div>
          <div className="footer__groups">
            <div className="footer__group">
              <div className="footer__group-title">
                {i18n.t(`main.footer.contacts.support`)}
              </div>
              <div className="footer__group-desc display5">
                <a className="green-text" href="mailto:support@svetofore.ru">
                  support@svetofore.ru
                </a>
              </div>
              <div className="footer__group-desc display5">
                <a className="green-text" href="tel:88002227079">
                  8 (800) 222-70-79
                </a>
              </div>
            </div>
            <div className="footer__group">
              <div className="footer__social">
                <div className="footer__group-desc display6">
                  <a className="green-text" href="https://max.ru/id2462225394_biz" target="_blank">
                    <img src="/img/max.png" alt="" className="footer__app-img"/>
                  </a>
                </div>
                <div className="footer__group-desc display6">
                  <a className="green-text" href="https://dzen.ru/svetoforelogistic" target="_blank">
                    <img src="/img/zen.svg" alt="" className="footer__app-img"/>
                  </a>
                </div>
                <div className="footer__group-desc display6">
                  <a className="green-text" href="https://vk.com/svetoforlogistica" target="_blank">
                    <img src="/img/vk.svg" alt="" className="footer__app-img"/>
                  </a>
                </div>
              </div>
            </div>
            <div className="footer__group">
              <div className="footer__group-title">
                {i18n.t(`main.footer.copyright`)}
              </div>
            </div>
          </div>
        </div>
        <div className="footer__apps2">
          <a href="" className="footer__market m-btn m-btn-primary m-btn-triangle-right">
            <img src="/img/app3.png" alt=""/>
          </a>
          <a href="" className="footer__telegram m-btn m-btn-primary m-btn-triangle-right">
            <img src="/img/app4.svg" alt=""/>
            <span className="text13">
              {i18n.t(`main.footer.bot`)}
            </span>
          </a>
        </div>
      </div>
    </div>
  </footer>
}
